import React, { Component } from 'react';
import Select from '../Select';
import { ModalHeader, ModalBody } from '../Modal';
import { Field, reduxForm, formValueSelector, change, SubmissionError, destroy } from 'redux-form';
import PlacesAutocomplete from 'react-places-autocomplete';
import { fetchShards } from '../../actions/shard';
import localize from '../localize';
import { connect } from 'react-redux';
import { locationSearch, geocode } from '../../api';
import { compose } from 'redux';
import './FindLocation.css';

// Compatibility with redux-form.
const SelectInput = (props) => (
 	<Select
    {...props}
    value={props.input.value}
    onChange={(value) => props.input.onChange(value.value)}
    onBlur={() => props.input.onBlur(props.input.value)}
    options={props.options}
  />
);

//Wrapper for PlacesAutocomplete, and compatibility with redux-form;
export const PlacesInputBare = ({ input, country, i18n, inputProps, meta, ...props }) => {
  const inputValue = input.value.location || input.value.location === '' ?
    input.value.location : input.value;

	inputProps = {
		value: inputValue,
		onChange: location => {
			input.onChange({ location, isSelected: false })
		},
    onBlur: () => {
      input.onBlur(input.value);
    },
    ...inputProps
	};

	const options = {
		componentRestrictions: {
			country: country
		}
	};

	return <div className="placesInput">
           <PlacesAutocomplete {...props} debounce={ 600 } onSelect={ location => input.onChange({ location, isSelected: true }) } inputProps={inputProps} options={options} googleLogo={true} />
           <q-icon name="search" size="md" />
           { meta.error && <em className="error">{i18n.t(meta.error)}</em> }
         </div>;
};

const PlacesInput = localize()(PlacesInputBare);

export class LocationSearchBare extends Component {
  componentWillMount() {
    this.props.fetchShards();
  }

  render() {
    const { handleSubmit, i18n, selectedShard, country, defaultCountry, clearField, shards, shardsLoaded, header, buttonText, place, onSubmit, submitting } = this.props;
    let form;

    if(shardsLoaded) {
      const shardOptions = shards.map(({ shard }) => {
        return { value: shard, label: i18n.t(`shards.${shard}`, false) };
      })

      const countries = selectedShard ? shards.find(({ shard }) => shard === selectedShard).countries : [];

      const countryOptions = countries.map(country => ({ value: country, label: i18n.t(`countries.${country}`, false) }));

      form = <form>
              <q-grid>
                <q-col lg-size="6">
                  <label>{i18n.t('shard')}</label>
                  <Field name="shard" options={shardOptions} component={SelectInput} clearable={false} onChange={(e, newValue) => {
                    defaultCountry(newValue, shards);
                    clearField('place');
                  }} />
                </q-col>
                <q-col lg-size="6">
                  <label>{i18n.t('country')}</label>
                  <Field name="country" options={countryOptions} component={SelectInput} clearable={false} onChange={() => clearField('place')} />
                </q-col>
                <q-col lg-size="12">
                  <Field name="place" component={PlacesInput} inputProps={{ placeholder: i18n.t('placeholder'), disabled: !country }} country={country} />
                </q-col>
              </q-grid>
              <div className="text-center form-actions">
                <q-button color="primary" disabled={!place || !place.isSelected || submitting} onClick={handleSubmit(onSubmit)}>{buttonText || i18n.t('search')}</q-button>
              </div>
            </form>;
    }

    return <div>
            <ModalHeader>
              {header}
            </ModalHeader>
            <ModalBody>
              {form}
            </ModalBody>
           </div>;
  }
}

const selector = formValueSelector('locationFind');

const LocationSearch = compose(localize('search.modal'), reduxForm({
  destroyOnUnmount: false
}), connect(
  state => {
    return {
      selectedShard: selector(state, 'shard'),
      country: selector(state, 'country'),
      place: selector(state, 'place'),
      shards: state.shards.shards,
      shardsLoaded: state.shards.isLoaded
    };
  },
  dispatch => {
    return {
      clearField: (field) => {
        dispatch(change('locationFind', field, ''))
      },
      clearFields: (fields) => {
        fields.forEach(field => dispatch(change('locationFind', field, '')));
      },
      defaultCountry: (shard, shards) => {
        dispatch(change('locationFind', 'country', shards.find(s => s.shard === shard).countries[0]))
      },
      fetchShards: () => {
        dispatch(fetchShards());
      }
    }
  }
))(LocationSearchBare);

let LocationSelect = compose(localize('search.modal.step_location'), reduxForm({
  destroyOnUnmount: false
}), connect(state => {
  return {
    location_id: selector(state, 'location_id')
  }
}))(props => {
  const { handleSubmit, i18n, locations, header } = props;

  const options = locations.map(location => ({ label: location.city, value: location.id }));

  return (
    <div className="location-select">
      <ModalHeader>
        {header}
      </ModalHeader>
      <ModalBody>
        <form>
          <div className="field-narrow">
            <label>{ i18n.t('location_label') }</label>
            <Field name="location_id" component={SelectInput} options={options} clearable={false} />
            <div className="text-center form-actions">
              <q-button onClick={handleSubmit(props.onSubmit)} disabled={!!!props.location_id}>{ i18n.t('select') }</q-button>
            </div>
          </div>
        </form>
      </ModalBody>
    </div>
  );
});

class FindLocation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      step: 'search'
    };
  }

  handleLocationSelect(values, dispatch) {
    if(this.props.onLocationSelected) {
      const location = this.state.locations.find(location => location.id === values.location_id);

      this.props.onLocationSelected({
        location,
        ...values
      });

      dispatch(destroy('locationFind'));
    }
  }

  async handleSearch(values, dispatch) {
    const geocodeResults = await geocode(values.place.location)
    if (!geocodeResults) {
      throw new SubmissionError({
        place: 'errors.location.not_specific_enough'
      });
    }

    const enResults = geocodeResults.english
    const locResults = geocodeResults.local

    if (!enResults || !locResults || enResults.length === 0 || locResults.length === 0) {
      throw new SubmissionError({
        place: 'errors.location.not_specific_enough'
      });
    }

    const point = enResults[0].geometry.location
    const address_components = enResults[0].address_components
    const local_components = locResults[0].address_components

    // console.log('SEARCH', values.place.location, point, address_components)

    //Allows a fallback to a less specific type if provided.
    const findComponentByType = (arr, ...types) => {
      const components = types.map(type => {
        return arr.find(c => c.types.find(t => t === type));
      });

      return components.find(c => c);
    }

    const city = findComponentByType(address_components, 'neighborhood', 'sublocality', 'locality', 'administrative_area_level_5', 'administrative_area_level_4', 'administrative_area_level_3', 'administrative_area_level_2') || { long_name: 'n/a' };
    const region = findComponentByType(address_components, 'administrative_area_level_1', 'administrative_area_level_2', 'administrative_area_level_3') || { long_name: 'n/a' };
    const country = findComponentByType(address_components, 'country');

    const localCity = findComponentByType(local_components, 'neighborhood', 'sublocality', 'locality', 'administrative_area_level_5', 'administrative_area_level_4', 'administrative_area_level_3', 'administrative_area_level_2') || { long_name: 'n/a' };
    const localRegion = findComponentByType(local_components, 'administrative_area_level_1', 'administrative_area_level_2', 'administrative_area_level_3') || { long_name: 'n/a' };

    // const isValid = !!(city && region && country);
    const isValid = !!country && address_components.length >= 2

    if(isValid) {
      const searchParams = { country: country['short_name'], region: region['long_name'], city: city['long_name'], local_region: localRegion['long_name'], local_city: localCity['long_name'], point, shard: values.shard };

      const { locations, exact_match } = await locationSearch(searchParams);

      this.setState({
        locations
      });

      if(!locations || locations.length === 0) {
        this.props.onLocationNotFound && this.props.onLocationNotFound({
          shard: values.shard,
          location_id: null,
          location_searched: searchParams
        });
      } else if(exact_match) {
        this.handleLocationSelect({
          location_id: locations[0].id,
          shard: values.shard,
          location_searched: searchParams
        }, dispatch)
      } else {
        this.setState({
          step: 'select'
        });
      }
    } else {
      throw new SubmissionError({
        place: 'errors.location.not_specific_enough'
      });
    }
  }

  render() {
    const { shard, country, locationHeader, searchHeader, searchButtonText } = this.props;

    const form = this.props.form || 'locationFind';

    return <div>
            { this.state.step === 'search' && <LocationSearch header={searchHeader} buttonText={searchButtonText} form={form}
                                                              onSubmit={(values, dispatch) => this.handleSearch(values, dispatch)}
                                                              initialValues={{ shard:shard, country:country }} /> }

            { this.state.step === 'select' && <LocationSelect header={locationHeader} form={form}
                                                              locations={this.state.locations}
                                                              onSubmit={(values, dispatch) => this.handleLocationSelect(values, dispatch)} /> }
           </div>;
  }
}

export default FindLocation;



// WEBPACK FOOTER //
// ./src/components/FindLocation/index.js